<template>
  <div>
    <!-- banner模块 -->
    <div class="common-banner-box">
      <el-carousel :interval="5000">
        <el-carousel-item v-for="(item,index) in banner_list" :key="index">
          <!-- <img class="common-banner" src="../assets/img/banner.png" alt=""> -->
          <img class="common-banner" :src="$baseUrl+item" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 公告滚动模块 -->
    <div class="notice-module justify-center align-center">
      <div class="common-container">
        <div class="notice-module-action justify-between">
          <div class="notice-module-action-title justify-center align-center" @click="jumpMore(2)">
            <img src="../assets/img/icon/notice.png" alt="">
            <span>通知公告</span>
          </div>
          <div class="notice-module-action-text">
            <transition name="slide"> 
              <div 
                class="notice-module-action-animation justify-between align-center"
                :key="notice_text.id"
                @mouseenter="mouseenter"
                @mouseleave="mouseleave"
                @click="openDetail(notice_text.val.id,2)"
              >
                <span>{{ notice_text.val.title }}</span>
                <span>{{ timeFormat(notice_text.val.createTime) }}</span>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div> 
    <!-- 公告内容模块 -->
    <div class="affiche-module">
      <div class="common-container">
        <div class="affiche-module-action justify-between">
          <div class="affiche-module-action-left">
            <div class="public-action-item" @click="openDetail(affiche_obj.id)">
              <img :src="$baseUrl+affiche_obj.thumbnailUrl" alt="">
              <div class="public-action-item-text">
                {{affiche_obj.title}}
              </div>
            </div>
          </div>
          <div class="affiche-module-action-right">
            <div class="affiche-module-action-nav align-center">
              <div 
                class="affiche-module-action-nav-item justify-center align-center"
                v-for="(item,index) in affiche_title" 
                :key="index"
                :class="index==affiche_index?'affiche-module-action-nav-item-select':''"
                @click="afficheNavFun(index)"
              >{{item}}</div>
              <div class="affiche-module-action-nav-lower justify-center align-center" @click="jumpMore()">MORE+</div>
            </div>
            <div class="affiche-module-action-today" @click="openDetail(affiche_obj.id)">
              <div class="affiche-module-action-today-content justify-between">
                <div class="affiche-module-action-today-content-left align-center">
                  <div class="flex-col align-center">
                    <span>{{strCut(timeFormat(affiche_obj.createTime),2,'end')}}</span>
                    <span>{{strCut(timeFormat(affiche_obj.createTime),7,'start')}}</span>
                  </div>
                </div>
                <div class="affiche-module-action-today-content-right flex-col">
                  <span>{{ affiche_obj.title }}</span>
                  <span>{{ affiche_obj.synopsis }}</span>
                </div>
              </div>
            </div>
            <div class="affiche-module-action-list">
              <div class="affiche-module-action-list-item justify-between align-center" v-for="(item,index) in affiche_list" :key="index" @click="affiche_obj = item">
                <div class="align-center">
                  <div class="affiche-module-action-list-item-dot"></div>
                  <span class="affiche-module-action-list-item-text">{{item.title}}</span>
                </div>
                <span>{{timeFormat(item.createTime)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 课程与活动模块 -->
    <div class="common-container">
      <div class="public-title align-center f-w">课程与活动</div>
      <div class="public-action">
        <div class="public-action-item" v-for="(item,index) in science_action1" :key="index" @click="openDetail2(item.id,'/coursePage')">
          <img :src="$baseUrl+item.thumbnailUrl" alt="">
          <div class="public-action-item-text">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <!-- 协会概况模块 -->
    <div class="survey-module">
      <div class="survey-module-action">
        <div class="common-container">
          <div class="survey-module-title flex-col">
            <span>{{ this.$wangzhan.name=='安徽'?'学会概况':'协会概况' }}</span>
            <span>Association Overview</span>
          </div>
          <div class="survey-module-body justify-between">
            <div class="survey-module-body-item" v-for="(item,index) in xhgk_list" :key="index" @click="jumpXhgk(item.id,item.name)">
              <div class="survey-module-body-item-case align-center">
                <div class="survey-module-body-item-img">
                  <img :src="require(`../assets/img/xhgk/${index+1}.png`)" alt="">
                </div>
                <div class="survey-module-body-item-text flex-col">
                  <span>{{item.name}}</span>
                  <span>{{item.text}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 学术交流模块 -->
    <div class="common-container">
      <div class="public-title align-center f-w">学术交流</div>
      <div class="public-action">
        <div class="public-action-item" v-for="(item,index) in science_action2" :key="index" @click="openDetail2(item.id,'/sciencePage')">
          <img :src="$baseUrl+item.thumbnailUrl" alt="">
          <div class="public-action-item-text">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <!-- 科学普及模块 -->
    <div class="common-container">
      <div class="public-title align-center f-w">科学普及</div>
      <div class="public-action justify-between" v-for="(item,index) in science_action3" :key="index" @click="openDetail2(item.id,'/popularizationPage')">
        <div class="public-action-left">
          <img :src="$baseUrl+item.thumbnailUrl" alt="">
        </div>
        <div class="public-action-right flex-col">
          <span>{{ item.title }}</span>
          <div>{{ item.address }}<br/><br/>{{item.startTime+'~'+item.endTime }}</div>
          <span style="cursor: pointer;">查看详情></span>
        </div>
      </div>
    </div>
    <!-- 心理咨询模块 -->
    <div class="common-container">
      <div class="public-title align-center f-w">心理咨询</div>
      <div class="counseling-action">
        <div class="counseling-item align-center" v-for="(item,index) in xinli_list" :key="index" @click="jumpzxDetail(item.id)">
          <img :src="$baseUrl + item.thumbnailUrl" alt="">
        </div>
      </div>
    </div>
    <!-- 悬浮查询模块 -->
    <div class="floating-query" v-if="floating_show">
      <div class="floating-query-title justify-between">
        <div class="floating-query-title-tabs justify-between align-center">
          <div class="floating-query-title-tabs-item" 
            v-for="(item,index) in floating_tabs" 
            :key="index"
            :class="index==floating_index?'floating-query-title-tabs-item-select':''"
            @click="floating_index = index"
          >{{ item }}</div>
        </div>
        <div class="floating-query-title-x" @click="floating_show = false">×</div>
      </div>
      <div class="floating-query-action">
        <el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" label-height="auto" class="demo-ruleForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="证书编号" prop="certificateNumber" v-if="floating_index===0">
            <el-input v-model="ruleForm.certificateNumber" placeholder="请输入证书编号"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="memberAccount" v-else>
            <el-input v-model="ruleForm.memberAccount" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item>
             <div class="search-submit justify-center align-center" @click="submitForm('ruleForm')">立即查询</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {getNoticeList,getScienceList,getConsultList} from '@/api/index'
export default {
  props:['banner_list'],
  data(){
    return{
      notice_list: [
        {
          title:'',
          createTime:'0000-00-00'
        },
      ],
      notice_index: 0,
      notice_timer: null,
      xhgk_list:[
        {name:this.$wangzhan.name=='安徽'?'学会简介':'协会简介',text:'INTRODUCTION',id:1},
        {name:this.$wangzhan.name=='安徽'?'学会章程':'协会章程',text:'RULES',id:2},
        {name:'证书查询',text:'CerTIFICATE QUERY',id:1},
        {name:'组织机构',text:'ORGANIZATION',id:3},
        {name:'理事会',text:'COUNCIL',id:4},
        {name:'会员查询',text:'MEMBER QUERY',id:2},
      ],
      affiche_title:[
        (this.$wangzhan.name=='安徽'?'学会动态':'协会动态'),
        '通知公告',
        '行业新闻',
      ],
      affiche_index:0,
      affiche_list:[],
      affiche_obj:{
        id:'',
        thumbnailUrl:'',
        title:'暂无内容',
        createTime:'1970-01-01',
        synopsis:'暂无内容',
      },
      science_action1:[],
      science_action2:[],
      science_action3:[],
      floating_tabs:[
        '证书查询',
        '会员查询'
      ],
      floating_index:0,
      floating_show:true,
      ruleForm: {
        memberAccount: '',
        name:'',
        certificateNumber:''
      },
      rules: {
        memberAccount: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
          ],
          certificateNumber: [
            { required: true, message: '请输入证书编号', trigger: 'blur' },
          ],
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
      },
      xinli_list:[]
    }
  },
  computed: {
    notice_text() {
      return {
        id: this.notice_index,
        val: this.notice_list[this.notice_index]
      }
    }
  },
  created() {
    this.getNoticeListFun()
    this.afficheNavFun(0)
    this.getList('course')
    this.getList('academic')
    this.getList('science')
    this.getXinLiList()
  },
  destroyed(){
    clearInterval(this.notice_timer);
  }, 
  methods:{ 
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const z = window.btoa(encodeURIComponent(JSON.stringify(this.ruleForm)));
          this.$router.push({
            path:'/memberPage',query:{id:this.floating_index+1,z}
          })
          window.scrollTo(0,0);
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    mouseenter() {
      clearInterval(this.notice_timer)
    },
    mouseleave(){
        this.startMove()
    },
    startMove() {
      this.notice_timer = setTimeout(() => {
        if (this.notice_index === this.notice_list.length - 1) {
          this.notice_index = 0;
        } else {
          this.notice_index += 1;
        }
        this.startMove();
      }, 2000)
    },
    getNoticeListFun(){
      getNoticeList({pageNum:1,pageSize:10,type:'notice'}).then((res)=>{
        this.notice_list = res.data.list
        this.startMove()
      })
    },
    afficheNavFun(index){
      this.affiche_index = index
      if(index==0){
        this.getFun('association')
      }else if(index == 1){
        this.getFun('notice')
      }else if(index == 2){
        this.getFun('news')
      }
    },
    getFun(type){
      getNoticeList({
        pageNum: 1,
        pageSize: 4,
        type,
      })
      .then(({ data }) => {
        this.affiche_list = data.list;
        this.affiche_obj = data.list.length>0?data.list[0]:{
          id:'',
          thumbnailUrl:'',
          title:'暂无内容',
          createTime:'1970-01-01',
          synopsis:'暂无内容',
        }
      })
      .finally(() => {});
    },
    openDetail(id,a_id){
      this.$router.push({
        path:'/newsPage',query:{detail_id:id,id:a_id?a_id:this.affiche_index+1}
      })
      window.scrollTo(0,0);
    },
    openDetail2(id,path){
      this.$router.push({
        path,query:{detail_id:id}
      })
      window.scrollTo(0,0);
    },
    jumpMore(a_id){
      this.$router.push({ path: '/newsPage',query:{id:a_id?a_id:this.affiche_index+1}});
      window.scrollTo(0, 0)
    },
    jumpXhgk(id,name){
      if(name=='证书查询'||name=='会员查询'){
        this.$router.push({ path: '/memberPage',query:{id}});
      }else{
        this.$router.push({ path: '/surveyPage',query:{id}});
      }
      window.scrollTo(0, 0)
    },
    // 课程与活动 or 学术交流 or 科学普及--------------start
    getList(type){
      getScienceList({
        pageNum: 1,
        pageSize: type=='science'?1:3,
        type,
      })
      .then(({ data }) => {
        if(type=='course'){
          this.science_action1 = data.list
        }else if(type=='academic'){
          this.science_action2 = data.list
        }else{
          this.science_action3 = data.list
        }
      })
      .finally(() => {
      });
    },
    // 课程与活动 or 学术交流 or 科学普及--------------end
    // 心理咨询 -- start
    getXinLiList(){
      getConsultList({
        pageNum: 1,
        pageSize: 100,
      })
      .then(({ data }) => {
          this.xinli_list = data.list
      })
      .finally(() => {
      });
    },
    jumpzxDetail(id){
      this.$router.push({
        path:'/consultPage',query:{detail_id:id}
      })
      window.scrollTo(0, 0)
    },
    // 心理咨询 -- end
    // js处理方法--------------start
    timeFormat(date = '0000-00-00'){
    	let newDate=/\d{4}-\d{1,2}-\d{1,2}/g.exec(date)
    	return newDate[0]
    },
    strCut(string,num,direction){
      if(direction=='start'){
        return string.substring(0,num)
      }else if(direction=='end'){
        return string.substring(string.length-num,string.length)
      }
    },
    // js处理方法--------------end
  }
}
</script>
<style scoped lang="css" src="../assets/css/rem.css" />
<style scoped>
.slide-enter-active,
.slide-leave-active {
transition: all 0.5s linear;
}
.slide-enter {
transform: translateY(20px) scale(1);
opacity: 1;
}
.slide-leave-to {
transform: translateY(-20px) scale(0.8);
opacity: 0;
}
</style>
<style>
.common-banner-box .el-carousel__container{
  height: 503px !important;
}
.floating-query-action .el-form--label-top .el-form-item__label{
  padding: 0 !important;
}
</style>